<template>
  <div id="cac-home__action-links">
    <div 
      v-for="actionLink in actionLinks" 
      :key="actionLink.actionTitle" 
      class="action-link d-flex">
      <icon 
        :icon-name="actionLink.iconName" 
        view-box="0 0 50 50" 
        class="action-link__icon"/>
      <div class="d-flex flex-column col-md-12 ml-5">
        <router-link :to="{ name: actionLink.routeName }">
          <div class="d-flex align-items-center action-title">
            <span>{{ actionLink.actionTitle }}</span>
            <icon
              icon-name="arrow-right"
              view-box="0 0 20 20"
              class="ml-3"/>
          </div>
        </router-link>
        <p>{{ actionLink.actionHelpText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Icon from "StyleguideComponents/Icon.vue";

import { isEmpty as _isEmpty } from "lodash";

import STATE from "Constants/campaign/civicactioncenter/state";
import RouteNames from "Constants/campaign/civicactioncenter/routeNames";

import {
  MAP_PIN,
  CHECK_SQUARE,
  CAPITOL_BUILDING
} from "Constants/styleguide/iconNames";

export default {
  name: "ActionLinks",
  components: {
    Icon
  },
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, [
      "cacFindCandidates",
      "cacFindElectedOfficials",
      "cacVoterInformation"
    ]),
    actionLinks() {
      return [
        {
          routeName: RouteNames.VOTER_INFORMATION,
          iconName: CHECK_SQUARE,
          actionTitle:
            !_isEmpty(this.cacVoterInformation) &&
            !_isEmpty(this.cacVoterInformation.cta)
              ? this.cacVoterInformation.cta
              : this.$t("cac.app.your_voter_information"),
          actionHelpText: !_isEmpty(this.cacVoterInformation.description)
            ? this.cacVoterInformation.description
            : this.$t("cac.app.vote_early_absentee_balot")
        },
        {
          routeName: RouteNames.ELECTED_OFFICIALS,
          iconName: MAP_PIN,
          actionTitle:
            !_isEmpty(this.cacFindElectedOfficials) &&
            !_isEmpty(this.cacFindElectedOfficials.cta)
              ? this.cacFindElectedOfficials.cta
              : this.$t("cac.app.find_elected_officials"),
          actionHelpText: !_isEmpty(this.cacFindElectedOfficials.description)
            ? this.cacFindElectedOfficials.description
            : this.$t("cac.app.learn_about_representatives")
        },
        {
          routeName: RouteNames.CANDIDATES,
          iconName: CAPITOL_BUILDING,
          actionTitle:
            !_isEmpty(this.cacFindCandidates) &&
            !_isEmpty(this.cacFindCandidates.cta)
              ? this.cacFindCandidates.cta
              : this.$t("cac.app.find_your_candidates"),
          actionHelpText: !_isEmpty(this.cacFindCandidates.description)
            ? this.cacFindCandidates.description
            : this.$t("cac.app.learn_more_about_candidates")
        }
      ];
    }
  }
};
</script>
